import { CheckSquare, Download, X } from 'lucide-react';

import { Button } from '@g17eco/ui-modern/components/ui/button';

interface ListHeaderProps {
  resultCount: number;
  isSelectMode: boolean;
  onToggleSelectMode: () => void;
  selectedCount: number;
  allChecked: boolean;
  onToggleAll: () => void;
  onBulkDownload: () => void;
}

export const ListHeader = ({
  resultCount,
  isSelectMode,
  onToggleSelectMode,
  selectedCount,
  allChecked,
  onToggleAll,
  onBulkDownload,
}: ListHeaderProps) => (
  <div className='tw:flex tw:flex-wrap tw:items-center tw:gap-2 tw:text-sm'>
    {isSelectMode ? (
      <label className='tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer tw:pl-3'>
        <input
          type='checkbox'
          aria-label='Select all documents'
          checked={allChecked}
          onChange={onToggleAll}
          className='tw:h-4 tw:w-4 tw:cursor-pointer tw:accent-emerald-600'
        />
        <span className='tw:font-medium'>
          {selectedCount > 0 ? `${selectedCount} selected` : `${resultCount} result${resultCount === 1 ? '' : 's'}`}
        </span>
      </label>
    ) : (
      <span className='tw:text-ThemeTextMedium'>
        {resultCount} result{resultCount === 1 ? '' : 's'}
      </span>
    )}
    <Button
      variant={isSelectMode ? 'secondary' : 'link'}
      size='xs'
      onClick={onToggleSelectMode}
    >
      {isSelectMode ? (
        <>
          <X className='tw:size-3' />
          Cancel
        </>
      ) : (
        <>
          <CheckSquare className='tw:size-3' />
          Select
        </>
      )}
    </Button>
    {isSelectMode && selectedCount > 0 ? (
      <Button variant='outline' size='xs' onClick={onBulkDownload}>
        <Download className='tw:size-3' />
        Download {selectedCount}
      </Button>
    ) : null}
  </div>
);
